// Stable per-browser id so code-run rate limits apply per student, not per shared school IP
const KEY = "codingdrills_client_id";

export const clientId = () => {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = typeof crypto?.randomUUID === "function" ? crypto.randomUUID() : `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return "";
  }
};

export const clientHeaders = () => ({ "Content-Type": "application/json", "X-Client-Id": clientId() });
